

export const question = 'QUESTION'
export const confirmed = 'CONFIRMED'
export const recheck = 'RECHECK'

export const checkingStatuses = {
    question: question,
    confirmed: confirmed,
    recheck: recheck
}
